import { siteConfig } from "../siteConfig"

const onInputSequence = ($sequence, $basePairs, $blastLink) => {
    $basePairs.textContent = 'BP: ' + $sequence.value.replace(/\s+/g, '').length;
    $blastLink.href = 'https://blast.ncbi.nlm.nih.gov/Blast.cgi?PAGE_TYPE=BlastSearch&USER_FORMAT_DEFAULTS=on' +
        '&PAGE=MegaBlast&PROGRAM=blastn&QUERY=' + $sequence.value + `&JOB_TITLE=${siteConfig["name"]}&GAPCOSTS=0%25200' +
        '&MATCH_SCORES=1%2C-2&DATABASE=nr&BLAST_PROGRAMS=megaBlast&MAX_NUM_SEQ=100&SHORT_QUERY_ADJUST=on' +
        '&EXPECT=10&WORD_SIZE=28&REPEATS=repeat_9606&TEMPLATE_TYPE=0&TEMPLATE_LENGTH=0&FILTER=m' +
        '&SHOW_OVERVIEW=on&SHOW_LINKOUT=on&ALIGNMENT_VIEW=Pairwise&MASK_CHAR=2&MASK_COLOR=1&' +
        'GET_SEQUENCE=on&NUM_OVERVIEW=100&DESCRIPTIONS=100&ALIGNMENTS=100&FORMAT_OBJECT=Alignment' +
        '&FORMAT_TYPE=HTML&OLD_BLAST=false`
};

const onClickClearSequence = ($sequence, $basePairs) => {
    $sequence.value = '';
    $basePairs.textContent = 'BP: 0';
}

export default ($sequence) => {
    if ($sequence) {
        const $blastLink = document.querySelector('#blastLink')
        const $basePairs = document.querySelector('#basePairs')
        const $clearSequence = document.querySelector('#clearSequence')
        $sequence.addEventListener('input', () => onInputSequence($sequence, $basePairs, $blastLink))
        $clearSequence.addEventListener('click', () => onClickClearSequence($sequence, $basePairs, $blastLink))
    }
};
